import { useContext } from "react";
import PropTypes from "prop-types";
import { TermsContext } from "./context";

const TermsTitle = ({ children, id }) => {
    const { toggleActive, activeId, setIsInit } = useContext(TermsContext);

    const clickHandler = () => {
        if (!toggleActive || !id || !setIsInit) return;
        setIsInit(false);
        toggleActive(id);
    };
    const isActive = id === activeId ? true : false;

    return (
        <div
            aria-hidden="true"
            className={`accordion-header ${isActive ? "active" : ""}`}
            type="button"
            onClick={clickHandler}
        >
            <span className="accordion-title">{children}</span>
        </div>
    );
};

TermsTitle.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default TermsTitle;
